export const dataSetForSurvivalRate = {
    "B": {
        dataSets: [
            {
                tableCode: "bd_9bd_sz_cl_r2",
                industries: ["B"],
                variable: [ "V97043"]
            }
        ]
    },
    "C": {
        dataSets: [ 
            {
                tableCode: "bd_9bd_sz_cl_r2",
                industries: [ "C", "C10-C12", "C13_C14", "C15", "C16", "C17_18", "C19", "C20_C21", "C22", "C23", "C24_C25", "C26_C27", "C28", "C29_C30", "C31_C32", "C33"],
                variable: ["V97043"]
            }
        ]
    },
    "F": {
        dataSets: [
            {
                tableCode: "bd_9bd_sz_cl_r2",
                industries: [ "F" ],
                variable: ["V97043"]
            }
        ]
    },
    "M": {
        dataSets: [
            {
                tableCode: "bd_9bd_sz_cl_r2",
                industries: [ "M", "M69", "M70", "M71", "M72", "M73", "M74", "M75" ],
                variables: ["V97043"]
            }
        ]
    },
    "P": {
        dataSets: [
            {
                tableCode: "bd_9bd_sz_cl_r2",
                industries: [ "P", "P85" ],
                variable: ["V97043"]
            }
        ]
    },
    "R": {
        dataSets: [
            {
                tableCode: "bd_9bd_sz_cl_r2",
                industries: [ "R", "R90", "R91", "R92", "R93" ],
                variable: [ "V97043"]
            }
        ]
    },
    "S": {
        dataSets: [
            {
                tableCode: "bd_9bd_sz_cl_r2",
                industries: ["S", "S94", "S95", "S96"],
                variable: ["V97043"]
            }
        ]
    },
    "I": {
        dataSets: [
            {
                tableCode: "bd_9bd_sz_cl_r2",
                industries: [ "I", "I55", "I56" ],
                variable: ["V97043"]
            }
        ]
    },
    "J": {
        dataSets: [
            {
                tableCode: "bd_9bd_sz_cl_r2",
                industries: [ "J", "J58", "J59", "J60", "J61", "J62", "J620", "J6201", "J6202", "J6203", "J6209", "J63"],
                variable: ["V97043"]
            }
        ]
    },
    "N": {
        dataSets: [
            {
                tableCode: "bd_9bd_sz_cl_r2",
                industries: [ "N77",  "N771", "N7711", "N7712",  "N772", "N7721", "N7722", "N7729", "N773", "N7731", "N7732", "N7733", "N7734", "N7735", "N7739", "N774", "N7740", "N78",  "N781", "N7810", "N782", "N7820", "N783", "N7830", "N79", "N791", "N7911", "N7912", "N799", "N7990", "N80",  "N801", "N8010", "N802", "N8020", "N803",  "N8030", "N81",  "N811", "N8110", "N812", "N8121", "N8122", "N8129", "N813", "N8130", "N82",  "N821", "N8211", "N8219", "N822", "N8220", "N823", "N8230", "N829", "N8291", "N8292", "N8299"],
                variable: ["V97043"]
            }          
        ]
    }, 
    "D": {
        dataSets: [
			{
                tableCode: "bd_9bd_sz_cl_r2",
                industries: [ "D" ],
                variable: [ "V97043" ]
            }
        ]
    },
	"G": {
        dataSets: [
			{
                tableCode: "bd_9bd_sz_cl_r2",
                industries: [ "G","G45", "G46", "G47", "G471", "G472", "G473", "G474", "G475", "G476", "G477", "G478", "G479" ],
                variable: [ "V97043"]
            }
        ]
    },
	"H": {
        dataSets: [ 
			{
                tableCode: "bd_9bd_sz_cl_r2",
                industries: [ "H","H49", "H50", "H51", "H52", "H53" ],
                variable: [ "V97043" ]
            }
        ]
    },
	"E": {
        dataSets: [
			{
                tableCode: "bd_9bd_sz_cl_r2",
                industries: [ "E" ],
                variable: [ "V97043" ]
            }
        ]
    },
	"L": {
        dataSets: [
			{
                tableCode: "bd_9bd_sz_cl_r2",
                industries: [ "L", "L68", "L681", "L6810", "L682", "L6820", "L683", "L6831", "L6832" ],
                variable: [ "V97043"]
            }
        ]
    }
}

//http://ec.europa.eu/eurostat/wdds/rest/data/v2.1/json/en/bd_9bd_sz_cl_r2?sinceTimePeriod=2008&precision=1&geo=LT&indic_sb=V97043&sizeclas=TOTAL&nace_r2=H52